export const DEFAULT_CONTACT_IS_CUSTOMER_TYPE = 'is_customer';
export const DEFAULT_CONTACT_IS_EMPLOYEE_TYPE = 'is_employee';
export const DEFAULT_CONTACT_IS_SUPPLIER_TYPE = 'is_supplier';
export const DEFAULT_CONTACT_IS_OTHER_TYPE = 'is_other';
